export default "__VITE_ASSET__C197xXmb__"